import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
import { HiShoppingCart, HiQuestionMarkCircle } from 'react-icons/hi';
// import PlanetCard from './PlanetCard';
import PlanetModal from './PlanetModal';
import { planetsData } from '../data/planetsData';
import WearGuide from './WearGuide';
import useSectionView from '../utils/useSectionView';
import {
  trackEvent,
  trackPlanetGuideOpen,
  trackPlanetOpen,
} from '../utils/analytics';
import '../styles/PlanetsCollection.css';

const PlanetsCollection = () => {
  const [selectedPlanet, setSelectedPlanet] = useState(null);
  const [showGuide, setShowGuide] = useState(false);
  const navigate = useNavigate();
  const sectionRef = useSectionView('collection');

  const openPlanet = (planet) => {
    setSelectedPlanet(planet);
    trackPlanetOpen(planet.name, 'collection');
  };

  const openGuide = () => {
    setShowGuide(true);
    trackPlanetGuideOpen('collection');
  };

  const goToConsultation = () => {
    trackEvent('cta_click', {
      cta: 'get_consultation',
      cta_location: 'collection',
    });
    navigate('/account/consultations');
  };
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  return (
    <section className="planets-collection" id="collection" ref={sectionRef}>
      <motion.div
        ref={ref}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        variants={containerVariants}
        className="planets-collection-container"
      >
        {/* Section Header */}
        <motion.div
          className="collection-header"
          variants={{
            hidden: { opacity: 0, y: 50 },
            visible: { opacity: 1, y: 0 },
          }}
        >
          
          <h2 className="section-title">
            Shop by Planet
          </h2>

          <p className="section-subtitle">
           Discover carefully selected, lab-certified gemstones aligned with planetary energies.
           Each stone is tested for authenticity and chosen to support balance, clarity, and well-being in your life.
          </p>
          <motion.button
            className="find-planet-btn"
            onClick={openGuide}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <HiQuestionMarkCircle />
            <span>How to wear your gemstone bracelet</span>
          </motion.button>
        </motion.div>

        <WearGuide isOpen={showGuide} onClose={() => setShowGuide(false)} />

        {/* Planets Grid */}
        {/* <motion.div className="planets-grid" variants={containerVariants}>
          {planetsData.map((planet) => (
            <PlanetCard
              key={planet.id}
              planet={planet}
              onClick={() => setSelectedPlanet(planet)}
            />
          ))}
        </motion.div> */}

        <div className="planets-grid">
          {planetsData.map((planet, index) => (
            <motion.div
              key={planet.name}
              className="planet-circle"
              style={{ backgroundColor: planet.color }}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ scale: 1.1, boxShadow: '0 8px 24px rgba(0,0,0,0.12)' }}
              whileTap={{ scale: 0.95 }}
              onClick={() => openPlanet(planet)}
            >
              {/* planetsData has carried an image for every planet all
                  along; the circle only ever drew the text glyph. */}
              {planet.image ? (
                <img
                  src={planet.image}
                  alt={planet.name}
                  className="planet-photo"
                  loading="lazy"
                  draggable={false}
                />
              ) : (
                <div className="planet-symbol">{planet.symbol}</div>
              )}
              <div className="planet-name">{planet.name}</div>
            </motion.div>
          ))}
        </div>        

        {/* Consultation Banner */}
        <motion.div
          className="planets-info-banner"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 1 }}
        >
          <div className="banner-content">
            <div className="banner-icon">
              <HiShoppingCart />
            </div>
            <div className="banner-text">
              <h3>Need Expert Guidance?</h3>
              <p>
                Not sure which gemstone suits you best? Get a personalized 
                consultation from our certified Vedic astrologers before you buy.
              </p>
            </div>
          </div>
          <motion.button
            className="consultation-btn"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={goToConsultation}
          >
            Get Consultation
          </motion.button>
        </motion.div>

        {/* Trust Badges */}
        {/* <motion.div
          className="trust-badges"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ delay: 1.2 }}
        >
          <div className="trust-badge">
            <img src="/api/placeholder/80/80" alt="Certified" className="badge-img" />
            <span>IGI Certified</span>
          </div>
          <div className="trust-badge">
            <img src="/api/placeholder/80/80" alt="Authentic" className="badge-img" />
            <span>100% Authentic</span>
          </div>
          <div className="trust-badge">
            <img src="/api/placeholder/80/80" alt="Energized" className="badge-img" />
            <span>Vedic Energized</span>
          </div>
          <div className="trust-badge">
            <img src="/api/placeholder/80/80" alt="Trusted" className="badge-img" />
            <span>10,000+ Happy Customers</span>
          </div>
        </motion.div> */}
      </motion.div>

      <PlanetModal
        planet={selectedPlanet}
        onClose={() => setSelectedPlanet(null)}
      />
    </section>
  );
};

export default PlanetsCollection;